import {BrowserRouter as Router, Routes, Route, Link} from "react-router-dom";
import Naming from "./Pages/Naming";
import Unstaking from "./Pages/Unstake"


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Naming />} />
        <Route path="/unstake" element={<Unstaking />} />
      </Routes>
    </Router>
  );
}

export default App;